export * from './communication-other-type-selection.component';
export * from './communication-other-type-selection.module';